<template>
  <div class="action-item">
    <b-tabs justified>
      <b-tab title="Details">
        <b-form>
          <b-row>
            <b-col cols="6">
            </b-col>
            <b-col cols="6">
              <b-row>
                <b-col cols="3">
                  <b-form-group
                      :label="reInspectionPhotosButtonLabel"
                      label-size="sm"
                  >
                    <photo-viewer
                        v-if="numberOfReInspectionPhotos > 0"
                        :photoFn="getReInspectionPhotosFn"
                        button-variant="primary"
                    >
                      <template #text>
                        <span class="d-none d-md-inline">Show Photos</span>
                      </template>
                    </photo-viewer>
                    <b-btn v-else
                           variant="yellow"
                           size="sm"
                           :disabled="true">
                      No photos<span class="d-none d-md-inline"> found</span>
                    </b-btn>
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group
                      :label="actionPhotosButtonLabel"
                      label-size="sm"
                  >
                    <photo-viewer
                        v-if="numberOfPhotos > 0"
                        :photoFn="getActionPhotosFn"
                    >
                      <template #text>
                        <span class="d-none d-md-inline">Show Photos</span>
                      </template>
                    </photo-viewer>
                    <b-btn v-else
                           variant="yellow"
                           size="sm"
                           :disabled="true">
                      No photos<span class="d-none d-md-inline"> found</span>
                    </b-btn>
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group
                      label="Inspection Photos"
                      label-size="sm"
                  >
                    <photo-viewer
                        v-if="numberOfInspectionPhotos > 0"
                        :photoFn="getInspectionPhotosFn"
                        button-variant="primary"
                    >
                      <template #text>
                        <span class="d-none d-md-inline">Show Photos</span>
                      </template>
                    </photo-viewer>
                    <b-btn v-else
                           variant="primary"
                           size="sm"
                           :disabled="true">
                      No photos<span class="d-none d-md-inline"> found</span>
                    </b-btn>
                  </b-form-group>
                </b-col>
                <b-col cols="3" v-if="canDownloadReport">
                  <b-form-group
                      label="Download PDF"
                      label-size="sm"
                  >
                    <b-btn v-if="reportExists"
                           variant="primary"
                           size="sm"
                           :href="getDownloadUrl()"
                           target="_blank"
                    >
                      Download
                      <font-awesome-icon
                          :icon="['fal', 'download']"
                          size="sm"
                          class="ml-2"
                      ></font-awesome-icon>
                    </b-btn>
                    <b-btn v-else
                           variant="primary"
                           size="sm"
                           :disabled="true">
                      No file<span class="d-none d-md-inline"> found</span>
                    </b-btn>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row v-for="(row, index) in form.readOnly.detailsTopSection" :key="Math.random()">
            <b-col v-for="(label, field) in row" cols="6">
              <b-form-group
                  :label="label"
                  label-size="sm"
              >
                <div class="b-form-group-content read-only">
                  <span v-text="getFormValue(field)"></span>
                </div>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6">
              <b-form-group
                  label="Assigned to:"
                  label-for="reviewer"
                  label-size="sm"
              >
                <assign-select
                    v-if="allowedAssign"
                    ref="assignSelect"
                    v-model="reviewer"
                    @confirm="updateAssignee($event)"
                    :options="assignOptions"
                    :loading="form.loading.reviewer"
                    :confirm-buttons="true"
                    :disabled="true"
                >
                </assign-select>
                <div v-else
                     class="b-form-group-content">
                  {{ reviewer.label }}
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group
                  label="Status"
                  label-size="sm"
              >
                <div class="b-form-group-content">
                  {{ status | uppercaseFirst }}
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                  label="Tags"
                  label-size="sm"
              >
                <tag-select
                    v-if="allowedToTag && showTags"
                    ref="tagSelect"
                    v-model="tags"
                    :confirm-buttons="true"
                    :disabled="!allowedToTag"
                    :loading="form.loading.tags"
                ></tag-select>
                <b-badge
                    v-else-if="tags.length > 0"
                    variant="primary"
                    pill
                    v-for="tag in tags"
                    :key="tag.name"
                    tag="div"
                >
                  {{ tag.name }}
                </b-badge>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="this.canViewWorkOrders">
            <b-col cols="6">
              <b-form-group
                label="Work Order"
                label-size="sm"
              >
                <text-field
                  v-model="workOrder"
                  :placeholder="workOrder"
                  :loading="form.loading.workOrder"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                label="FRA Action Due Date"
                label-size="sm"
              >
                <div class="b-form-group-content">
                  {{ dueDate | formatDate }}
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="workPlanName">
            <b-col cols="6">
              <b-form-group
                  label="Work Plan"
                  label-size="sm"
              >
                <div class="b-form-group-content">
                  {{ workPlanName }}
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                  label="Work Plan Due Date"
                  label-size="sm"
              >
                <div class="b-form-group-content">
                  {{ workPlanDueDate | formatDate }}
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group
                  label="Internal due date"
                  label-size="sm"
              >
                <date-picker
                    v-if="authorized"
                    ref="datePicker"
                    id="internalDueDate"
                    v-model="internalDueDate"
                    :loading="form.loading.internalDueDate"
                    :target-date="dueDate"
                    :confirm-buttons="true"
                    :reduceButtons="true"
                >
                </date-picker>
                <div v-else
                     class="b-form-group-content">
                  {{ internalDueDate | formatDate }}
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                  v-if="!this.canViewWorkOrders"
                  label="FRA Action Due Date"
                  label-size="sm"
              >
                <div class="b-form-group-content">
                  {{ dueDate | formatDate }}
                </div>
              </b-form-group>
              <b-form-group
                  v-if="this.canViewWorkOrders"
                  label="Internal Due Date"
                  label-size="sm"
              >
                <div class="b-form-group-content">
                  {{ internalDueDate | formatDate }}
                </div>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-for="(row, index) in form.readOnly.detailsOther" :key="index">
            <b-col v-for="(label, field) in row" cols="6">
              <b-form-group
                  :label="label"
                  label-size="sm"
              >
                <div class="b-form-group-content read-only">
                  <span v-text="getFormValue(field)"></span>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-tab>
      <b-tab title="Action History"
             @click="getNotes"
      >
        <vue-element-loading :active="tabs.notes.loading"></vue-element-loading>

        <b-row v-for="(row, index) in form.readOnly.actionHistoryTopSection" :key="index">
          <b-col v-for="(label, field) in row" cols="6">
            <b-form-group
                :label="label"
                label-size="sm"
            >
              <div class="b-form-group-content read-only">
                <span v-text="getFormValue(field)"></span>
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <action-note
            v-for="note in notes"
            :key="note.clientActionNoteId || note.id"
            :date="note.createdDate"
            :label="note.label"
            :user="note.user"
            :admin-user="note.admin_user"
            :note="note.note"
            :files="note.files"
        >
        </action-note>
      </b-tab>
    </b-tabs>
    <vue-element-loading :active="loading"></vue-element-loading>
  </div>
</template>

<script>
import TextField from '@/components/Form/TextField';
import TagSelect from '@/components/Form/TagSelect';
import DatePicker from '@/components/Form/DatePicker';
import AssignSelect from '@/components/Form/AssignSelect';
import ActionButtons from '@/components/Action/ActionButtons';
import ActionNote from '@/components/Action/ActionNote';
import PhotoViewer from '@/components/Image/PhotoViewer';
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import ActionAssign from '@/services/Action/ActionAssign';
import ActionStatus from '@/services/Action/ActionStatus';
import Action from '@/services/Action/Action';
import PropertyAssessment from '@/services/Property/PropertyAssessment';
import Vue from 'vue';
import ErrorMixin from '@/components/Notifications/ErrorMixin';
import { PERMISSION_TYPE_PROPERTIES, PROPERTIES_DOWNLOAD_REPORTS } from '@/config/permission';
import riskhub from "@/services/Riskhub/Riskhub";

export default {
  name: 'Action-Item',
  components: {
    TextField,
    TagSelect,
    DatePicker,
    AssignSelect,
    ActionButtons,
    ActionNote,
    PhotoViewer,
  },
  mixins: [ErrorMixin],
  props: {
    clientActionId: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      assignOptions: [],
      getActionPhotosFn: () => Action.getPhotos({ clientActionId: this.clientActionId }),
      getInspectionPhotosFn: () => PropertyAssessment.getPhotos(this.propertyId, this.propertyAssessmentId),
      getReInspectionPhotosFn: () => Action.getPreviousRecommendationOnsitePhotos({ clientActionId: this.clientActionId }),
      tabs: {
        notes: {
          loading: false,
        },
      },
      showTags: false,
      form: {
        loading: {
          reviewer: false,
          internalDueDate: false,
          workOrder: false,
          tags: false,
        },
        disabled: {
          reviewer: true,
          internalDueDate: true,
          workOrder: true,
        },
        readOnly: {
          detailsTopSection: [
            {
              comments: 'Comments',
              recommendation: 'Recommendation',
            },
            {
              minQuantity: 'Min quantity',
              maxQuantity: 'Max quantity',
            },
            {
              specification: 'Specification',
              rate: 'Rate',
            },
            {
              minCost: 'Min cost',
              maxCost: 'Max cost',
            },
          ],
          detailsOther: [
            {
              uprn: 'UPRN',
              designation: 'Designation',
            },
            {
              address: 'Address',
              tenure: 'Tenure',
            },
            {
              propertyHierarchyType: 'Hierarchy Level',
              riskProfile: 'Risk profile',
            },
            {
              actionType: 'Action type',
              priority: 'Priority',
            },
            {
              question: 'Question',
              category: 'Category',
            },
          ],
          actionHistoryTopSection: [
            {
              comments: 'Comments',
              recommendation: 'Recommendation',
            },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      responsibleTeam: state => state.action.currentResponsibleTeam,
      status: state => state.action.status,
      dueDate: state => state.action.dueDate,
      workPlanName: state => state.action.workPlanName,
      workPlanDueDate: state => state.action.workPlanDueDate,
      workOrder: state => state.action.workOrder,
      uprn: state => state.action.uprn,
      designation: state => state.action.designation,
      address: (state) => {
        const {
          propertyHierarchyType,
          numberRange,
          buildingName,
          unitNumber,
          streetNumber,
          validatedStreetNumber = streetNumber || '',
          street,
          validatedStreet = street || '',
          town,
          postcode,
        } = state.action;

        const formattedHierarchyAndUnitNumber = propertyHierarchyType && unitNumber
          ? `${propertyHierarchyType} ${unitNumber}`
          : '';

        return [
          formattedHierarchyAndUnitNumber,
          numberRange,
          buildingName,
          `${validatedStreetNumber} ${validatedStreet}`,
          town,
          postcode,
        ].filter(Boolean).join('\n');
      },
      tenure: state => state.action.tenure,
      postcode: state => state.action.postcode,
      riskProfile: state => state.action.riskProfile,
      actionType: state => state.action.actionType,
      priority: state => state.action.priority,
      question: state => state.action.question,
      category: state => state.action.category,
      comments: state => state.action.comments,
      recommendation: state => state.action.recommendation,
      minQuantity: state => state.action.minQuantity,
      maxQuantity: state => state.action.maxQuantity,
      specification: state => state.action.specification,
      rate: state => state.action.rate,
      minCost: state => state.action.minCost,
      maxCost: state => state.action.maxCost,
      notes: state => state.action.notes,
      authorized: state => state.action.authorized,
      activeTeamId: state => state.action.activeTeamId,
      numberOfPhotos: state => state.action.numberOfPhotos,
      numberOfInspectionPhotos: state => state.action.numberOfInspectionPhotos,
      numberOfReInspectionPhotos: state => state.action.numberOfReInspectionPhotos,
      propertyId: state => state.action.propertyId,
      propertyAssessmentId: state => state.action.propertyAssessmentId,
      propertyHierarchyType: state => state.action.propertyHierarchyType,
      reportExists: state => state.action.reportExists,
      showReInspectionPhotos: state => state.action.showReInspectionPhotos,
    }),

    canDownloadReport() {
      return (
        this.$can(this.$perm.PROPERTIES_DOWNLOAD_REPORTS, this.$perm.PERMISSION_TYPE_PROPERTIES)
      );
    },

    reviewer: {
      get() {
        const label = this.$store.state.action.currentAssigned;
        const userId = this.$store.state.action.currentResponsibleUserId;
        const teamId = this.$store.state.action.currentResponsibleTeamId;
        return {
          label,
          userId,
          teamId,
        };
      },
      set(reviewer) {
        // this.$store.commit('updateReviewer', reviewer);
      },
    },

    internalDueDate: {
      get() {
        return this.$store.state.action.internalDueDate;
      },
      set(newDate) {
        this.updateInternalDueDate(newDate);
      },
    },

    workOrder: {
      get() {
        return this.$store.state.action.workOrder;
      },
      set(newWorkOrder) {
        this.updateWorkOrder(newWorkOrder);
      },
    },

    tags: {
      get() {
        const tags = this.$store.state.action.tags;
        if (tags) {
          return tags.split(',').map(tag => ({
            name: tag,
            code: tag,
          }));
        }
        return [];
      },
      set(tags) {
        this.updateTags(tags);
      },
    },

    allowedAssign() {
      if (this.status === ActionStatus.APPROVED()) {
        return false;
      }

      return this.authorized && this.$can(this.$perm.ACTIONS_ASSIGN, this.$perm.PERMISSION_TYPE_ACTION);
    },

    allowedToTag() {
      return this.authorized && this.$can(this.$perm.ACTIONS_TAG, this.$perm.PERMISSION_TYPE_ACTION);
    },

    reInspectionPhotosButtonLabel() {
      return this.numberOfReInspectionPhotos > 0 ? 'New Action Photos' : 'Re-Inspection Photos';
    },

    actionPhotosButtonLabel() {
      return this.numberOfReInspectionPhotos > 0 ? 'Original Action Photos' : 'Action Photos';
    },
  },

  filters: {
    uppercaseFirst(string) {
      if (!string) {
        return '';
      }

      return string.charAt(0)
        .toUpperCase() + string.slice(1);
    },
    brackets(string) {
      if (!string) {
        return '';
      }

      return `(${string})`;
    },
    formatDate(date) {
      return riskhub.formatDate(date) || 'N/A';
    },
  },

  watch: {
    clientActionId: {
      handler(newId) {
        this.loading = true;
        this.$store.dispatch('fetchAction', newId)
          .then(async () => {
            if (this.allowedAssign) {
              this.assignOptions = await ActionAssign.getFormattedOptions(this.activeTeamId);
            }
          })
          .catch(() => {
            this.$notify({
              duration: 5000,
              title: 'Error',
              text: 'This action could not currently be loaded right now. Please try again later.',
              type: 'error',
            });
            this.$emit('close', true);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      immediate: true,
    },
  },

  async mounted() {
    this.showTags = false;
    Vue.$model = Action;
    await this.$store.dispatch('refreshTags');
    this.showTags = true;
  },

  methods: {
    /**
     * Obtains form value for given field
     */
    getFormValue(field) {
      const costs = [
        'rate',
        'minCost',
        'maxCost',
      ];

      if (costs.includes(field)) {
        if (!this.$can(this.$perm.ACTIONS_VIEW_COSTS, this.$perm.PERMISSION_TYPE_ACTION)) {
          return '';
        }
      }

      return this[field];
    },

    /**
     * Retrieve notes
     * */
    async getNotes() {
      if (Array.isArray(this.notes)) {
        return;
      }

      this.tabs.notes.loading = true;

      try {
        const { data } = await Action.getNotes({ clientActionId: this.clientActionId });
        const notes = data.data.map(item => {
          item.note = riskhub.formatDateFromStr(item.note)
          return item
        });
        this.$store.dispatch('updateActionField', { field: 'notes', value: notes });
      } finally {
        this.tabs.notes.loading = false;
      }
    },

    /**
     * @param newTags
     */
    async updateTags(newTags) {
      this.form.loading.tags = true;

      const tags = newTags.map(tag => tag.name);
      try {
        await this.$store.dispatch('updateTags', { clientActionIds: this.clientActionId, tags });

        this.$notify({
          title: 'Success',
          text: 'This action has been tagged successfully.',
          type: 'success',
        });
        this.$store.dispatch('refreshActions');
        this.$store.dispatch('refreshTags');
        this.$refs.tagSelect.disable();
      } finally {
        this.form.loading.tags = false;
      }
    },

    /**
     * @param newDate
     */
    async updateInternalDueDate(newDate) {
      // Validate
      this.form.loading.internalDueDate = true;
      const clientActionId = this.clientActionId;
      const params = {
        clientActionId,
        internalDueDate: newDate,
      };

      try {
        await this.$store.dispatch('updateInternalDueDate', params);

        this.$notify({
          duration: 7000,
          title: 'Success',
          text: 'The internal due date has been updated successfully.',
          type: 'success',
        });
        this.$refs.datePicker.disable();
      } catch (e) {
        this.showValidationError(e);
      } finally {
        this.form.loading.internalDueDate = false;
      }
    },

    async updateWorkOrder(newWorkOrder) {
      this.form.loading.workOrder = true;

      const clientActionId = this.clientActionId;
      const params = {
        clientActionId,
        workOrder: newWorkOrder,
      };

      try {
        await this.$store.dispatch('updateWorkOrder', params);

        this.$notify({
          duration: 7000,
          title: 'Success',
          text: 'The work order has been updated successfully.',
          type: 'success',
        });

      } catch (e) {
        this.showValidationError(e);
      } finally {
        this.form.loading.workOrder = false;
      }
      this.$store.dispatch('refreshActions');
    },

    /**
     * @param newAssignee
     * @returns {Promise<void>}
     */
    async updateAssignee(newAssignee) {
      this.form.loading.reviewer = true;

      const clientActionIds = this.clientActionId;
      const { userId, teamId } = newAssignee;

      const params = {
        clientActionIds,
        userId,
        teamId,
      };

      try {
        const response = await ActionAssign.assign(params);
        const { result } = response.data;

        let title = 'Action assigned';
        let text = 'The assignee has been changed successfully.';
        let type = 'success';

        if (!result) {
          title = 'Action not assigned';
          type = 'warn';
          text = 'Action has failed to be assigned. Please check your email for more information.';
          this.$notify({
            duration: 7000,
            title,
            text,
            type,
          });
          return;
        }

        this.$notify({
          duration: 7000,
          title,
          text,
          type,
        });
        this.$refs.assignSelect.disable();
        // Update the action state
        this.$store.dispatch('refreshActions');
      } catch (e) {
        const { error } = e.response.data;
        let text = 'Something went wrong. Please try again later.';
        if (error && error.message) {
          text = error.message;
        }

        this.$notify({
          duration: 7000,
          title: 'Error',
          text,
          type: 'error',
        });
      } finally {
        this.form.loading.reviewer = false;
      }

      try {
        await this.$store.dispatch('refreshAction');
      } catch (e) {
        this.$emit('close');
      }
    },
    getDownloadUrl() {
      const url = PropertyAssessment.getDownloadSnapshotReportUrl(this.propertyId, this.propertyAssessmentId);
      return `${url}?token=${this.$store.getters.authToken}`;
    },
    canViewWorkOrders() {
      return this.$can(this.$perm.ACTIONS_VIEW_WORK_ORDERS, this.$perm.PERMISSION_TYPE_ACTION) ||
          this.$can(this.$perm.ACTIONS_VIEW_ALL, this.$perm.PERMISSION_TYPE_ACTION);
    },
  },
};
</script>

<style lang="scss">
.b-form-group-content {
  color: $purple;
  font-weight: 300;
}

.action-item {
  .form-group {
    margin-bottom: 1.5rem;
  }

  .b-form-group-content.read-only {
    white-space: pre-line;
  }
}
</style>
